const getMonth = (isoDate: string | number | Date): string => `${new Date(isoDate).toLocaleString('en-us', { month: 'short' })}`
export default getMonth
